import { v4 as uuidv4 } from "uuid";
import React, { useEffect, useState, Suspense} from "react";
import { Button, Grid, Backdrop, Box, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Background from "./Background.png";
import Logo from "./Logo.svg";
import DoneIcon from "@mui/icons-material/Done";



const EngineerDashBoard = () => {
  const [uuid, setuuid] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const [open, setOpen] = useState(false);
  const [iscopied, setIsCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const timestamp = Date.now();
  const expirationtime = timestamp + 900000;
  let navigate = useNavigate();



  const generatelink = () => {
    const uniqueID = uuidv4();
    setuuid(uniqueID);
    setshowmodal(true);
    setOpen(true);
    setIsCopied(false);

  };

//   useEffect(()=>{
//  const handleload=()=>{
//   setLoading(true)
//  }

//  window.addEventListener('load', handleload);
//  console.log(loading);

//  console.log("loading is set to true");
//   },[])


  const pubURL = process.env.REACT_APP_API_URL;
  // const url2 = `${pubURL}customer/ra?uu=${uuid}&tf=${expirationtime}`;
  // const url1 = `${pubURL}engineer/ra?uu=${uuid}&tf=${expirationtime}`;
  const url2 = `${pubURL}customer/${uuid}?&tf=${expirationtime}`;
  const url1 = `${pubURL}engineer/${uuid}?&tf=${expirationtime}`;
  // const url2 = `https://10.198.33.108/customer/${uuid}?&tf=${expirationtime}`;
  // const url1 = `https://10.198.33.108/engineer/${uuid}?&tf=${expirationtime}`;
  localStorage.setItem("customlink", url1);
  localStorage.setItem("customlink_customer", url2);
  console.log("the expiration time is", expirationtime);
  console.log("the engineer", url1);
  console.log("the customer", url2);



  console.log("the expired link is", localStorage);
  const copy = (text) => {
    const tempinput = document.createElement("input");
    tempinput.value = text;
    document.body.appendChild(tempinput);
    tempinput.select();
    document.execCommand("copy");
    document.body.removeChild(tempinput);
    setIsCopied(true);
  };
  const redirect = () => {
    // navigate(`/engineer/ra?uu=${uuid}&tf=${expirationtime}`);
    navigate(`/engineer/${uuid}?&tf=${expirationtime}`);

  };


    return (
     
        <div
        style={{
          height: "100vh",
          background: "black",
  
          backgroundImage: `url(${Background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img src={Logo} alt="client logo" style={{ marginLeft: "10px" }} />
        {!showmodal && (
          <div
            style={{
              height: "90vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "50%",
            }}
          >
            <h1
              style={{
                marginTop: "25vh",
                color: "white",
                fontFamily: "sans-serif",
                fontSize: "50px",
              }}
            >
              AR Remote <br />
              Assistance
            </h1>
  
            <p style={{ color: "white", fontSize: "18px" }}>
              Click to generate meeting link
            </p>
            <Button
              variant="contained"
              onClick={generatelink}
              size="medium"
              style={{ marginTop: "1%", fontSize: "20px", borderRadius: "6px" }}
            >
              {" "}
              Generate link
            </Button>
          </div>
        )}
        {showmodal && (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 10 }}
            style={{ backdropFilter: "blur(5px)" }}
            open={open}
          >
            <Grid
              container
              style={{
                justifyContent: "center",
                alignItems: "center",
                height: "90vh",
              }}
            >
              <Box
                boxShadow={10}
                style={{ padding: "10px" }}
                sx={{
                  backgroundColor: "#214045",
                  borderRadius: "5px",
                  width: "550px",
                  height: "325px",
                }}
              >
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <CloseIcon
                    sx={{ color: "white", cursor: "pointer" }}
                    onClick={() => setshowmodal(false)}
                  />
                </Grid>
                <h3 style={{ color: "white", marginLeft: "5px" }}>
                  Share the link with the user and proceed to the meeting room.
                </h3>
  
                <Grid
                  item
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "10%",
                    marginTop: "6.5%",
                  }}
                >
                  <p style={{ color: "white", marginLeft: "5px" }}>
                    Copy link to be shared with the user
                  </p>
  
                  <Stack direction="row" spacing={2}>
                    <div
                      style={{
                        border: "1px solid #CCC",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px",
                        borderRadius: "3px",
                        color: "white",
                        width: "90%",
                        overflow: "hidden",
                        textOverflow: "clip",
                        whiteSpace: "nowrap",
                        marginLeft: "5px",
                      }}
                    >
                      {url2}
                    </div>
                    <div style={{ marginTop: "10px", marginRight: "10px" }}>
                      {iscopied ? (
                        <DoneIcon
                          fontSize="large"
                          sx={{ color: "white" }}
                          variant="contained"
                        />
                      ) : (
                        <ContentCopyIcon
                          fontSize="large"
                          sx={{ color: "white", cursor: "pointer" }}
                          variant="contained"
                          onClick={() => copy(url2)}
                        />
                      )}
                    </div>
                  </Stack>
                  <div style={{ marginTop: "30px" }}>
                    <p style={{ color: "white", marginLeft: "5px" }}>
                      Navigate to meeting room to wait for user
                    </p>
                    <Button
                      variant="contained"
                      style={{ margin: "0px auto", width: "100%" }}
                      onClick={redirect}
                    >
                      {" "}
                      Start Support Session
                    </Button>
                  </div>
                </Grid>
              </Box>
            </Grid>
          </Backdrop>
        )}
      </div>
    
  
    );
  
};

const DashBoard = () => {
  return <EngineerDashBoard />;
};

export default DashBoard;
